import React from 'react'
import { Link } from 'react-router-dom'
import white from '../Img/White-bg.png'

function ProfileCreate() {
  return (
    <div>
        <div className='m-4 flex justify-center'>
        <h1 className='font-bold text-lg'>Add Profile Details</h1>
      </div>
      <div className='flex flex-col items-center space-y-2'>
        <img src={white} alt="" />
        <h2 className='font-semibold'>Add photo</h2>
      </div>
      <div className='mx-3 space-y-2'>
        <h2 className='font-semibold'>Name</h2>
        <input className='px-3 w-[300px]  py-2 border border-black rounded-3xl' type="text" placeholder='Your Name' />
      </div>
      <div className='mx-3 space-y-2'>
        <h2 className='font-semibold'>About</h2>
        <textarea name='message ' rows='4' className='px-3 w-[300px] border-black  py-2 border rounded-2xl' type="text" placeholder='Write about you' />
      </div>
      <div className='mx-3 space-y-2'>
        <h2 className='font-semibold'>Twitter</h2>
        <input className='px-3 w-[300px]  py-2 border border-black rounded-3xl' type="text" placeholder='Twitter link' />
      </div>
      <div className='mx-3 space-y-2'>
        <h2 className='font-semibold'>Telegram</h2>
        <input className='px-3 w-[300px]  py-2 border border-black rounded-3xl' type="text" placeholder='Telegram link' />
      </div>
      
      
      <div className='mx-3 mt-2'>
        <h2 className='font-semibold'>Add you Web3 identity</h2>
        <div className='mx-2 mt-3 flex space-x-3'>
          <div className='flex'>
          <input type="checkbox" name='Lens' value="Lens" />
          <p>Lens</p>
          </div>
          <div className='flex'>
          <input type="checkbox" name='ENS' value="ENS" />
          <p>ENS</p>
          </div>
          
        </div>
      </div>
      <div className='drop-shadow-lg shadow-lg h-[20px] z-20'></div>
      <div  className='z-10'>
      <Link to="/profile" className='px-20 mx-10  py-3 mt-8 absolute bg-black font-semibold text-white rounded-3xl'>Mint Profile NFT</Link>
      </div>
      {/* <div className='drop-shadow-lg shadow-lg h-[20px] 
      '></div> */}
      

    </div>
  )
}

export default ProfileCreate